// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*  imported from TableCell.module.scss  */
.TableCell-module-Root_21E {
  position: relative;
  box-sizing: border-box;
  padding: 8px 24px;
  font-family: var(--display-font-family);
  user-select: none;
  color: #333f48;
  transition: background-color 0.3s linear; }
  .TableCell-module-Root_21E.TableCell-module-stickyLeft_236, .TableCell-module-Root_21E.TableCell-module-stickyRight_3He {
    position: sticky;
    z-index: 3; }
  .TableCell-module-Root_21E.TableCell-module-stickyLeft_236 {
    left: 0; }
  .TableCell-module-Root_21E.TableCell-module-stickyRight_3He {
    right: 0; }

th.TableCell-module-Root_21E {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.43;
  text-transform: uppercase;
  color: #576875;
  background-color: #eee; }

td.TableCell-module-Root_21E {
  font-size: 1rem;
  line-height: 1.5; }
  td.TableCell-module-Root_21E:first-child {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px; }
  td.TableCell-module-Root_21E:last-child {
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px; }

.TableCell-module-Content_2Kv {
  overflow: hidden; }

.TableCell-module-Resizer_USc {
  position: absolute;
  z-index: 2;
  top: 0;
  right: -3px;
  width: 6px;
  height: 100%;
  cursor: col-resize; }
  .TableCell-module-Resizer_USc::after {
    position: absolute;
    top: 10%;
    left: 50%;
    display: block;
    width: 1px;
    height: 80%;
    content: '';
    background-color: rgba(0, 0, 0, 0.1);
    transform: translateX(-50%); }

th.TableCell-module-Root_21E .TableCell-module-Content_2Kv {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; }

.TableCell-module-Root_21E:last-child .TableCell-module-Resizer_USc::after {
  display: none; }

/* Sizes */
/* размеры s и l отсутствуют в дизе, когда будут, стили надо поменять */
.TableCell-module-sSizes_3oV {
  height: 44px; }

.TableCell-module-mSizes_1Y1 {
  height: 64px; }

.TableCell-module-lSizes_1bR {
  height: 84px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Table/Cell/TableCell.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,uCAAuC;EACvC,iBAAiB;EACjB,cAAc;EACd,wCAAwC,EAAE;EAC1C;IACE,gBAAgB;IAChB,UAAU,EAAE;EACd;IACE,OAAO,EAAE;EACX;IACE,QAAQ,EAAE;;AAEd;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,sBAAsB,EAAE;;AAE1B;EACE,eAAe;EACf,gBAAgB,EAAE;EAClB;IACE,4BAA4B;IAC5B,+BAA+B,EAAE;EACnC;IACE,6BAA6B;IAC7B,gCAAgC,EAAE;;AAEtC;EACE,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB,EAAE;EACpB;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,2BAA2B,EAAE;;AAEjC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB,EAAE;;AAE3B;EACE,aAAa,EAAE;;AAEjB,UAAU;AACV,uEAAuE;AACvE;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE","sourcesContent":["@charset \"UTF-8\";\n/*  imported from TableCell.module.scss  */\n.TableCell-module-Root_21E {\n  position: relative;\n  box-sizing: border-box;\n  padding: 8px 24px;\n  font-family: var(--display-font-family);\n  user-select: none;\n  color: #333f48;\n  transition: background-color 0.3s linear; }\n  .TableCell-module-Root_21E.TableCell-module-stickyLeft_236, .TableCell-module-Root_21E.TableCell-module-stickyRight_3He {\n    position: sticky;\n    z-index: 3; }\n  .TableCell-module-Root_21E.TableCell-module-stickyLeft_236 {\n    left: 0; }\n  .TableCell-module-Root_21E.TableCell-module-stickyRight_3He {\n    right: 0; }\n\nth.TableCell-module-Root_21E {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.43;\n  text-transform: uppercase;\n  color: #576875;\n  background-color: #eee; }\n\ntd.TableCell-module-Root_21E {\n  font-size: 1rem;\n  line-height: 1.5; }\n  td.TableCell-module-Root_21E:first-child {\n    border-top-left-radius: 16px;\n    border-bottom-left-radius: 16px; }\n  td.TableCell-module-Root_21E:last-child {\n    border-top-right-radius: 16px;\n    border-bottom-right-radius: 16px; }\n\n.TableCell-module-Content_2Kv {\n  overflow: hidden; }\n\n.TableCell-module-Resizer_USc {\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: -3px;\n  width: 6px;\n  height: 100%;\n  cursor: col-resize; }\n  .TableCell-module-Resizer_USc::after {\n    position: absolute;\n    top: 10%;\n    left: 50%;\n    display: block;\n    width: 1px;\n    height: 80%;\n    content: '';\n    background-color: rgba(0, 0, 0, 0.1);\n    transform: translateX(-50%); }\n\nth.TableCell-module-Root_21E .TableCell-module-Content_2Kv {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.TableCell-module-Root_21E:last-child .TableCell-module-Resizer_USc::after {\n  display: none; }\n\n/* Sizes */\n/* размеры s и l отсутствуют в дизе, когда будут, стили надо поменять */\n.TableCell-module-sSizes_3oV {\n  height: 44px; }\n\n.TableCell-module-mSizes_1Y1 {\n  height: 64px; }\n\n.TableCell-module-lSizes_1bR {\n  height: 84px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
